import * as actionType from "./constants";
const initialState = {
    entityParams: {
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            filterKeys: null,
            list: null,
            order: null,
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0,
            fe_list_label: null
        },
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        tableConfig: null
    },
    getTaskManagerListResponse: {},
    getListForCommonFilterResponse: null,
    deleteTaskManagerResponse: {},
    cancelTaskManagerResponse: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_GENERAL_TASK_MANAGER_LIST_REQUEST:
            return {
                ...state,
                getTaskManagerListResponse: { isLoading: true }
            };
        case actionType.GET_GENERAL_TASK_MANAGER_LIST_SUCCESS:
            return {
                ...state,
                getTaskManagerListResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_GENERAL_TASK_MANAGER_LIST_FAILURE:
            return {
                ...state,
                getTaskManagerListResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.GET_GENERAL_TASK_MANAGER_TABLE_FILTER_REQUEST:
            return {
                ...state
            };
        case actionType.GET_GENERAL_TASK_MANAGER_TABLE_FILTER_SUCCESS: {
            const list = action.response?.detail || action.response?.list || action.response?.data || [];
            return {
                ...state,
                getListForCommonFilterResponse: {
                    loading: false,
                    success: true,
                    list,
                    count: action.response?.count ?? list.length
                }
            };
        }
        case actionType.GET_GENERAL_TASK_MANAGER_TABLE_FILTER_FAILURE:
            return {
                ...state,
                getListForCommonFilterResponse: { loading: false, success: false, ...action.error }
            };

        case actionType.DELETE_GENERAL_TASK_MANAGER_BY_ID_REQUEST:
            return {
                ...state,
                deleteTaskManagerResponse: { isLoading: true }
            };
        case actionType.DELETE_GENERAL_TASK_MANAGER_BY_ID_SUCCESS:
            return {
                ...state,
                deleteTaskManagerResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.DELETE_GENERAL_TASK_MANAGER_BY_ID_FAILURE:
            return {
                ...state,
                deleteTaskManagerResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.CANCEL_GENERAL_TASK_MANAGER_BY_ID_REQUEST:
            return {
                ...state,
                cancelTaskManagerResponse: { isLoading: true }
            };
        case actionType.CANCEL_GENERAL_TASK_MANAGER_BY_ID_SUCCESS:
            return {
                ...state,
                cancelTaskManagerResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.CANCEL_GENERAL_TASK_MANAGER_BY_ID_FAILURE:
            return {
                ...state,
                cancelTaskManagerResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.UPDATE_TASK_MANAGER_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: { isLoading: false, success: true, ...action.response }
            };
        case actionType.UPDATE_TASK_MANAGER_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { isLoading: true }
            };

        default:
            return state;
    }
};
